// Date 2020-07-27 14:39:38

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

import emMaMaintenanceScheduleList from "@/views/em/maintenance/EmMaMaintenanceScheduleList.vue";
import emMaMaintenanceScheduleEdit from "@/views/em/maintenance/EmMaMaintenanceScheduleEdit.vue";
import emMaMaintenanceWoList from "@/views/em/maintenance/EmMaMaintenanceWoList.vue";
import emMaMaintenanceWoEdit from "@/views/em/maintenance/EmMaMaintenanceWoEdit.vue";
import emMaMaintenanceWoTask from "@/views/em/maintenance/EmMaMaintenanceWoTask.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/maintenance/emMaMaintenanceCat/list",
        name: "emMaMaintenanceCatList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/maintenance/emMaMaintenanceCat/edit",
        name: "emMaMaintenanceCatEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    // {
    //     path: "/em/maintenance/emMaMaintenanceWo/list",
    //     name: "emMaMaintenanceWoList",
    //     component: emWorkflowListView,
    //     props: (route) => ({
    //         // prop_inline: route.query.inline,
    //         // prop_import: route.query.import,
    //         prop_export: route.query.export
    //     }),
    //     meta: metaObject
    // },
    // {
    //     path: "/em/maintenance/emMaMaintenanceWo/edit",
    //     name: "emMaMaintenanceWoEdit",
    //     component: emEntityEditView,
    //     meta: metaObject
    // },
    // {
    //     path: "/em/maintenance/emMaMaintenanceWo/task",
    //     name: "emMaMaintenanceWoTask",
    //     component: emWorkflowTaskView,
    //     meta: metaObject
    // },
//自定义页面注册
    {
        path: "/em/maintenance/emMaMaintenanceScheduleList",
        name: "emMaMaintenanceScheduleList",
        component: emMaMaintenanceScheduleList,
        meta: metaObject
    },
    {
        path: "/em/maintenance/emMaMaintenanceScheduleEdit",
        name: "emMaMaintenanceScheduleEdit",
        component: emMaMaintenanceScheduleEdit,
        meta: metaObject
    },
    {
        path: "/em/maintenance/emMaMaintenanceWoList",
        name: "emMaMaintenanceWoList",
        component: emMaMaintenanceWoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/maintenance/emMaMaintenanceWoEdit",
        name: "emMaMaintenanceWoEdit",
        component: emMaMaintenanceWoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/maintenance/emMaMaintenanceWoTask",
        name: "emMaMaintenanceWoTask",
        component: emMaMaintenanceWoTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]